exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".WidgetCoverageMap-widget {\n  padding: 0 !important; }\n", ""]);

